(() => {
  if (window.BFHomeInitialized) return;
  window.BFHomeInitialized = true;

  const activateVideo = (container) => {
    const video = container.querySelector('video[data-bf-lazy-video]');
    if (!video || video.dataset.loaded === 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
    });
    video.dataset.loaded = 'true';
    video.load();

    const playPromise = video.play();
    if (playPromise) playPromise.catch(() => {});
  };

  const initVideos = (root = document) => {
    root.querySelectorAll('[data-bf-video]').forEach((container) => {
      if (!('IntersectionObserver' in window)) {
        activateVideo(container);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            activateVideo(container);
            observer.disconnect();
          });
        },
        { rootMargin: '300px 0px' }
      );

      observer.observe(container);
    });
  };

  const initSliders = (root = document) => {
    root.querySelectorAll('[data-bf-slider]').forEach((slider) => {
      const track = slider.querySelector('[data-bf-slider-track]');
      if (!track || slider.dataset.initialized === 'true') return;
      slider.dataset.initialized = 'true';

      slider.querySelector('[data-bf-slider-prev]')?.addEventListener('click', () => {
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
      });
      slider.querySelector('[data-bf-slider-next]')?.addEventListener('click', () => {
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  };

  const imageFromSrcset = (srcset) => {
    const first = String(srcset || '')
      .split(',')
      .map((item) => item.trim().split(/\s+/)[0])
      .find(Boolean);

    return first || '';
  };

  const escapeAttribute = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  const imageIdentity = (src) => {
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.delete('width');
      return `${url.origin}${url.pathname}?${url.searchParams.toString()}`;
    } catch (error) {
      return String(src || '').replace(/([?&])width=\d+/g, '$1');
    }
  };

  const initGalleryPreview = (root = document) => {
    root.querySelectorAll('[data-bf-gallery-live-preview]').forEach((preview) => {
      if (preview.dataset.initialized === 'true') return;
      preview.dataset.initialized = 'true';

      const galleryUrl = preview.dataset.galleryUrl || '/pages/gallery?view=gallery-names';

      fetch(galleryUrl, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(`Gallery request failed: ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const seen = new Set();
          const images = Array.from(
            doc.querySelectorAll('.bf-gallery-page__lead-media img, .bf-gallery-page__media-button img, .bf-gallery-page__item img')
          )
            .map((img) => {
              const src = img.getAttribute('src') || img.dataset.src || imageFromSrcset(img.getAttribute('srcset'));
              const alt = img.getAttribute('alt') || "Blazin' Frames gallery image";
              return { src, alt };
            })
            .filter((item) => {
              if (!item.src) return false;
              const normalized = item.src.replace(/&amp;/g, '&');
              const identity = imageIdentity(normalized);
              if (seen.has(identity)) return false;
              if (/bull-logo|placeholder|blank/i.test(normalized)) return false;
              seen.add(identity);
              item.src = normalized;
              return true;
            })
            .slice(0, 3);

          if (!images.length) return;

          preview.innerHTML = images
            .map((image, index) => {
              const className = index === 0
                ? 'bf-gallery-preview__image bf-gallery-preview__image--large'
                : 'bf-gallery-preview__image';

              return `
                <a class="${className}" href="/pages/gallery?view=gallery-names">
                  <img src="${escapeAttribute(image.src)}" alt="${escapeAttribute(image.alt)}" loading="lazy" decoding="async">
                </a>
              `;
            })
            .join('');
          preview.classList.remove('bf-gallery-preview--loading');
        })
        .catch(() => {
          preview.classList.add('bf-gallery-preview--fallback');
          const empty = preview.querySelector('.bf-gallery-preview__empty');
          if (empty) {
            empty.innerHTML = '<strong>Open the Gallery for current frame photos.</strong><span>The homepage preview could not load the gallery feed.</span>';
          }
        });
    });
  };

  const repairPublicPlaceholders = (root = document) => {
    root.querySelectorAll('.bf-artist-teaser').forEach((section) => {
      const text = section.textContent.toLowerCase();
      if (text.includes('artist name coming soon') || text.includes('featured artist placeholder')) {
        section.remove();
      }
    });

    root.querySelectorAll('.bf-testimonials').forEach((section) => {
      const text = section.textContent.toLowerCase();
      if (text.includes('placeholder review:') || text.includes('customer name')) {
        section.remove();
      }
    });

    root.querySelectorAll('.bf-ready').forEach((section) => {
      const text = section.textContent.toLowerCase();
      if (!text.includes('example product title')) return;

      section.querySelector('.bf-ready__grid')?.remove();
      if (section.querySelector('.bf-ready__empty')) return;

      const empty = document.createElement('div');
      empty.className = 'bf-ready__empty';
      empty.innerHTML = '<p>No ready-to-ship frames are available right now. Finished one-of-one frames will appear here as soon as they are released.</p>';
      section.querySelector('.bf-shell')?.appendChild(empty);
    });
  };

  const init = (root = document) => {
    repairPublicPlaceholders(root);
    initVideos(root);
    initSliders(root);
    initGalleryPreview(root);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
